import { render, staticRenderFns } from "./bookmarkTab.vue?vue&type=template&id=76eaabf7&scoped=true&"
import script from "./bookmarkTab.vue?vue&type=script&lang=ts&"
export * from "./bookmarkTab.vue?vue&type=script&lang=ts&"
import style0 from "./bookmarkTab.vue?vue&type=style&index=0&id=76eaabf7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76eaabf7",
  null
  
)

export default component.exports